// extracted by mini-css-extract-plugin
export var cookieButton = "cookies-module--cookieButton--xpnBo";
export var cookieNotice = "cookies-module--cookieNotice--LiYf2";
export var sbShowMain = "cookies-module--sb-show-main--wjYfO";